import React from 'react';
import ReactDOM from 'react-dom';
import { clamp } from './utils';

const draggable = (Component, max) => {
  return class extends React.Component {
    componentDidMount() {
      this.rect =
        ReactDOM
          .findDOMNode(this)
          .getBoundingClientRect();
    }

    startUpdates = (e) => {
      document.addEventListener('mousemove', this.handleUpdate);
      document.addEventListener('touchmove', this.handleUpdate);
      document.addEventListener('mouseup', this.stopUpdates);
      document.addEventListener('touchend', this.stopUpdates);

      this.handleUpdate(e);
    }

    handleUpdate = (e) => {
      e.preventDefault();
      const { x, y } = this.getPosition(e);
      this.updatePosition(this.rect, x, y);
    }

    stopUpdates = () => {
      document.removeEventListener('mousemove', this.handleUpdate);
      document.removeEventListener('touchmove', this.handleUpdate);
      document.removeEventListener('mouseup', this.stopUpdates);
      document.removeEventListener('touchend', this.stopUpdates);
    }

    getPosition = (e) => {
      if(e.touches) {
        e = e.touches[0];
      }

      return {
        x: e.clientX,
        y: e.clientY
      };
    }

    getPercentageValue = (value) => `${(value / max) * 100}%`;

    getScaledValue = (value) => clamp(value, 0, 1) * max;

    updatePosition = (rect, clientX, clientY) => {
      const x = (clientX - rect.left) / rect.width;
      const y = (rect.bottom - clientY) / rect.height;

      if (this.props.vertical) {
        this.props.onChange(this.getScaledValue(y));
      } else {
        this.props.onChange(
          this.getScaledValue(x),
          this.getScaledValue(y)
        );
      }
    }

    render() {
      return (
        <Component
          startUpdates={this.startUpdates}
          getPercentageValue={this.getPercentageValue}
          getScaledValue={this.getScaledValue}
          {...this.props}
        />
      );
    }
  }
}

export default draggable;



// WEBPACK FOOTER //
// ./src/components/ColorPicker/draggable.js